// The left column in App admin's look: the brand, the menu, and "Signed in as" at the foot. On a phone it slides
// in over the page (the top bar's menu button) and closes on a link or on the dark backdrop.
import { Link } from 'react-router-dom'
import { X } from 'lucide-react'
import { FirstfundMark } from '@/components/FirstfundMark'
import { ROLE_LABEL } from '@/constants/roles'
import { ROUTES } from '@/constants/routes'
import { useMe } from '../session'
import { SidebarMenu } from './SidebarMenu'
import { useSidebar } from './useSidebar'

export function Sidebar() {
  const { user } = useMe()
  const { open, setOpen } = useSidebar()
  return (
    <>
      {open && <div className="fixed inset-0 z-30 bg-black/50 md:hidden" onClick={() => setOpen(false)} />}
      <aside
        className={`fixed left-0 top-0 z-40 flex h-full w-56 shrink-0 flex-col border-r border-slate-200 bg-white transition-transform duration-300 dark:border-slate-700 dark:bg-surface-dark md:static md:translate-x-0 ${
          open ? 'translate-x-0' : '-translate-x-full'
        }`}
        data-testid="sidebar"
      >
        <div className="flex h-12 shrink-0 items-center justify-between border-b border-slate-200 px-3 dark:border-slate-700">
          <Link to={ROUTES.overview.to()} className="flex items-center gap-2 text-charcoal dark:text-white">
            <FirstfundMark size={18} />
            <span className="text-sm font-bold">Campaign portal</span>
          </Link>
          <button
            type="button"
            className="icon-btn md:hidden"
            onClick={() => setOpen(false)}
            aria-label="Close menu"
          >
            <X size={16} />
          </button>
        </div>
        <SidebarMenu />
        <div className="border-t border-slate-200 p-2 dark:border-slate-700">
          <div className="rounded bg-surface-2 p-2 dark:bg-slate-800">
            <div className="text-2xs text-muted">Signed in as</div>
            <div className="truncate text-xs font-semibold text-default" data-testid="who">
              {user.name} · {ROLE_LABEL[user.role]}
            </div>
          </div>
        </div>
      </aside>
    </>
  )
}
